import React from 'react'
import Button from '~/components/_atoms/Button'
import { Audio } from '~/components/icons/YnsIcon'

const CoachInsightAudioPlayer = ({ audioUrl }) => {
  const [listenPressed, setListenPressed] = React.useState(false)

  return (
    <div className="grid grid-cols-[auto_1fr] gap-3">
      <div>
        <Button
          variant={listenPressed ? 'solid' : 'outline'}
          color="secondary"
          onClick={() => {
            setListenPressed(!listenPressed)
          }}
          endIcon={<Audio className="stroke-current" />}
        >
          Listen
        </Button>
      </div>
      {listenPressed && (
        <div className="flex justify-between gap-6">
          <audio className="w-full" controls preload="metadata" autoPlay>
            <source src={audioUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </div>
      )}
    </div>
  )
}

export default CoachInsightAudioPlayer
